var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_32)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19775 13.6451C6.19775 13.291 6.48484 13.0039 6.83898 13.0039H12.61C12.9641 13.0039 13.2512 13.291 13.2512 13.6451C13.2512 13.9993 12.9641 14.2864 12.61 14.2864H6.83898C6.48484 14.2864 6.19775 13.9993 6.19775 13.6451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0884 2.11261C11.8765 2.11261 11.6733 2.19679 11.5234 2.34663L2.75604 11.114L2.37938 12.6206L3.88599 12.244L12.6534 3.47659C12.7276 3.4024 12.7864 3.31432 12.8266 3.21738C12.8667 3.12044 12.8874 3.01654 12.8874 2.91161C12.8874 2.80669 12.8667 2.70279 12.8266 2.60585C12.7864 2.50891 12.7276 2.42083 12.6534 2.34663C12.5792 2.27244 12.4911 2.21358 12.3942 2.17343C12.2972 2.13328 12.1933 2.11261 12.0884 2.11261ZM10.5157 1.33893C10.9328 0.921825 11.4985 0.6875 12.0884 0.6875C12.3805 0.6875 12.6697 0.745028 12.9395 0.8568C13.2094 0.968572 13.4545 1.1324 13.6611 1.33893C13.8676 1.54545 14.0314 1.79064 14.1432 2.06048C14.255 2.33032 14.3125 2.61954 14.3125 2.91161C14.3125 3.20369 14.255 3.4929 14.1432 3.76274C14.0314 4.03258 13.8676 4.27777 13.6611 4.4843L4.75414 13.3912C4.66282 13.4825 4.5484 13.5473 4.42311 13.5787L1.57289 14.2912C1.33007 14.3519 1.0732 14.2808 0.896218 14.1038C0.719233 13.9268 0.648085 13.6699 0.70879 13.4271L1.42134 10.5769C1.45267 10.4516 1.51745 10.3372 1.60877 10.2459L10.5157 1.33893Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4008c4dd60ac338b998c17c3520f1e47.svg";
export { ForwardRef as ReactComponent };